import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxPopupModule } from 'devextreme-angular/ui/popup';

import { IvLiveComponent } from './components/ivlive/ivlive.component';
import { MainComponent } from './components/main/main.component';
import { MainTabPanelComponent } from './components/main-tab-panel/main-tab-panel.component';
import { TabDirective } from './directives/tab.directive';

import { SharedModule } from '../shared/shared.module';
import { WorkspaceModule } from '../workspace/workspace.module';
import { FavouritesModule } from '../favourites/favourites.module';
import { FuturesMonitorModule } from '../futures-monitor/futures-monitor.module';
import { AppStateService } from './services/app-state.service';
import { CommonService } from './services/common.service';
import { ChartsDashboardModule } from '../charts-dashboard/charts-dashboard.module';
import { AdvancedSearchModule } from 'app/advanced-search/advanced-search.module';


@NgModule({
  declarations: [
    IvLiveComponent,
    MainComponent,
    MainTabPanelComponent,
    TabDirective
  ],
  // TODO: Все модули не должны подключяаться в core
  imports: [
    CommonModule,
    DxPopupModule,
    SharedModule,
    WorkspaceModule,
    FavouritesModule,
    FuturesMonitorModule,
    ChartsDashboardModule,
    AdvancedSearchModule
  ],
  providers: [
    CommonService,
    AppStateService
  ]
})
export class CoreModule {
  private loadLibs = [
    {name: 'zingchart', lib: import('../../../node_modules/zingchart/zingchart-es6.min.js').then(m => m.default)},
    {name: 'Plotly', lib: import('../../../node_modules/plotly.js/dist/plotly.js').then(m => m)}
  ];

  constructor() {
    Promise.all(this.loadLibs.map(item => item.lib))
      .then(data => data.forEach((module, index) => window[this.loadLibs[index].name] = module));
  }
}
